/**
 * authToken.js — Merkezi auth token erisim katmani.
 *
 * Iki ayri oturum kapsami destekler:
 *
 *  1. NORMAL oturum (localStorage): klasik ogrenci/admin form girisi. Tum
 *     sekmeler paylasir, kalici (browser kapatilip acilinca da durur).
 *
 *  2. IMPERSONATION / auto-login oturumu (sessionStorage): admin "Ogrenci Gibi
 *     Gir" dedinde acilan YENI SEKMEYE ozeldir. localStorage'a DOKUNMAZ; boylece
 *     admin'in kendi sekmesi/oturumu etkilenmez ve 'storage' event'i tetiklenmez.
 *
 * Okuma onceligi: once sessionStorage, yoksa localStorage. Boylece impersonation
 * sekmesi her zaman kendi (ogrenci) token'ini kullanir; ayni anda baska sekmedeki
 * admin de localStorage token'i ile calismaya devam eder.
 *
 * Tum API cagrilari (AuthContext interceptor'lari ve axios hook'lari) bu helper'dan
 * okumalidir; storage'a dogrudan erismeyin.
 */

const TOKEN_KEY = 'auth_token';
const REFRESH_KEY = 'refresh_token';
// Impersonation sekmesini isaretleyen flag (banner gorunurlugu icin).
const IMPERSONATION_FLAG = 'impersonation';

/** Bu sekme impersonation (sessionStorage) modunda mi? */
export function isImpersonating() {
  try {
    return sessionStorage.getItem(TOKEN_KEY) != null;
  } catch {
    return false;
  }
}

/** Aktif access token — once sessionStorage, sonra localStorage. */
export function getToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

/** Aktif refresh token — aktif oturum kapsamiyla ayni yerden. */
export function getRefreshToken() {
  try {
    if (sessionStorage.getItem(TOKEN_KEY) != null) {
      return sessionStorage.getItem(REFRESH_KEY);
    }
    return localStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

/**
 * Normal (kalici) oturum yaz — localStorage. Form girisi / register / google /
 * refresh bu yolu kullanir. Diger sekmeleri 'storage' event'i ile haberdar eder.
 */
export function setLocalSession(token, refreshToken) {
  localStorage.setItem(TOKEN_KEY, token);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
}

/**
 * Impersonation / auto-login oturumu yaz — yalnizca sessionStorage. localStorage'a
 * DOKUNMAZ, dolayisiyla baska sekmeler ve admin oturumu etkilenmez, storage event
 * tetiklenmez.
 */
export function setSessionSession(token, refreshToken) {
  sessionStorage.setItem(TOKEN_KEY, token);
  if (refreshToken) sessionStorage.setItem(REFRESH_KEY, refreshToken);
  sessionStorage.setItem(IMPERSONATION_FLAG, '1');
}

/**
 * Refresh sonrasi yeni token'i AKTIF oturum kapsamina yazar. Impersonation
 * sekmesindeysek sessionStorage, degilsek localStorage guncellenir.
 */
export function updateActiveToken(token, refreshToken) {
  if (isImpersonating()) {
    sessionStorage.setItem(TOKEN_KEY, token);
    if (refreshToken) sessionStorage.setItem(REFRESH_KEY, refreshToken);
  } else {
    localStorage.setItem(TOKEN_KEY, token);
    if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
  }
}

/**
 * Aktif oturumu temizle.
 *  - Impersonation sekmesindeysek SADECE sessionStorage temizlenir; admin'in
 *    localStorage oturumu KORUNUR (kritik).
 *  - Aksi halde localStorage temizlenir (normal logout).
 */
export function clearToken() {
  if (isImpersonating()) {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_KEY);
    sessionStorage.removeItem(IMPERSONATION_FLAG);
  } else {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
  }
}
